import { Loader } from '@shared/ui/loader/loader';
import { AnimatePresence, motion } from 'framer-motion';
import { TeacherCard } from '@widgets/student/ui/teacher-card/teacher-card';
import { SearchAllTeachersOffer } from './search-all-teachers-offer';
import { matchingBodyVariants, matchedContentVariants, matchedItemVariants } from '../lib/teacher-matching-progress';
import s from '../teacher-matching-progress.module.scss';

export const MatchedTeachersResult = ({ teachers, teachersIsFetched, searchParams }) => (
	<motion.div
		key="matched"
		className={s.matchedBody}
		variants={matchingBodyVariants}
		initial="initial"
		animate="animate"
		exit="exit"
	>
		<AnimatePresence mode="wait" initial={false}>
			{teachersIsFetched ? (
				teachers?.length > 0 ? (
					<motion.div
						key="teachers"
						className={s.matchedList}
						variants={matchedContentVariants}
						initial="initial"
						animate="animate"
						exit="exit"
					>
						{teachers.map((teacher, index) => (
							<motion.div key={teacher?.teacher_slug || teacher?.id} variants={matchedItemVariants}>
								<TeacherCard {...teacher} isRecommended={index === 0} />
							</motion.div>
						))}
					</motion.div>
				) : (
					<motion.div
						key="empty"
						className={s.matchedEmpty}
						variants={matchingBodyVariants}
						initial="initial"
						animate="animate"
						exit="exit"
					>
						Мы не нашли подходящих преподавателей
					</motion.div>
				)
			) : (
				<motion.div
					key="loader"
					className={s.matchedLoader}
					variants={matchingBodyVariants}
					initial="initial"
					animate="animate"
					exit="exit"
				>
					<Loader/>
				</motion.div>
			)}
		</AnimatePresence>
		{teachersIsFetched && <SearchAllTeachersOffer searchParams={searchParams} />}
	</motion.div>
);
